<template>
  <div :class="`text-center mt-${topMargin}`">
    <v-icon class="spinner mx-3" size="50">fa fa-spinner</v-icon>
    <p class="mt-5 ml-3 title grey--text text--darken-2">
      <span>{{ caption }}</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    caption: {
      type: String,
      default: "Loading...",
    },
    topMargin: {
      type: String,
      default: "12",
    },
  },
};
</script>
